import { useXRay } from '../../context/XRayContext';
import { Badge } from '../../r2/Badge';
import styles from './XRayToggle.module.css';

const LAYER_COLORS: { layer: string; label: string }[] = [
  { layer: 'r1', label: 'R1 Primitives' },
  { layer: 'r2', label: 'R2 Elements' },
  { layer: 'r3', label: 'R3 Components' },
  { layer: 'r4', label: 'R4 Sections' },
  { layer: 'r5', label: 'R5 Pages' },
  { layer: 'r6', label: 'R6 Surfaces' },
];

export function XRayToggle() {
  const { enabled, toggle, highlightedLayer, setHighlightedLayer } = useXRay();

  return (
    <div
      data-crd-id="r3.bq-xray-toggle"
      data-crd-layer="r3"
      className={styles.container}
    >
      <button
        type="button"
        className={`${styles.toggle} ${enabled ? styles.active : ''}`}
        onClick={toggle}
        aria-pressed={enabled}
      >
        <span className={styles.track}>
          <span className={styles.thumb} />
        </span>
        <span className={styles.label}>X-Ray Mode</span>
      </button>

      {enabled && (
        <div className={styles.legend}>
          {LAYER_COLORS.map(({ layer, label }) => (
            <button
              key={layer}
              type="button"
              className={`${styles.legendItem} ${highlightedLayer === layer ? styles.legendActive : ''}`}
              onClick={() =>
                setHighlightedLayer(highlightedLayer === layer ? null : layer)
              }
            >
              <span
                className={styles.swatch}
                data-layer={layer}
              />
              <Badge variant="default">{label}</Badge>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
